import * as React from "react";

import { Nullable } from "types";
import { getClasses } from "utils";

import FieldWarning from "./FieldWarning";

interface PropsType {
  label: string;
  name?: string;
  value?: string | JSX.Element;
  warning?: string;
}

export default function ReadOnlyField(props: PropsType): Nullable<JSX.Element> {
  const { label, value, warning } = props;

  if (!value) return null;

  const name = props.name || label.toLowerCase().replace(/\s+/g, "-");

  return (
    <div
      className={getClasses("form--field read-only", {
        [name]: name,
        warning: !!warning,
      })}
    >
      <label className="form--field-label">{label}</label>
      <div className="value">
        <div>{value}</div>
        <i className="fas fa-check-circle" />
      </div>
      <FieldWarning {...{ warning }} />
    </div>
  );
}
